<template>
  <b-modal size="sm" button-size="sm" v-model="showModal" :title="title" hide-footer @hidden="cancelar">
    <b-container>
      <b-row>
        <b-col>
          <b-form @submit.prevent="submitForm">
            <lg-form-input v-model="form.descricao" label="Descricao: *" required></lg-form-input>

            <b-form-group label="Status:*" to="statusPais">
              <b-form-radio-group id="statusPais" size="sm" v-model="form.situacao" :options="options"
                name="situacao-options" class="d-flex">
              </b-form-radio-group>
            </b-form-group>
            <b-form-row>

              <b-col cols="3"></b-col>
              <b-col cols="6" class="text-center">
                <b-button id="salvarLocalCadastro" class=" my-2" size="sm" pill variant="success" type="submit">
                  <b-icon icon="check-circle" />
                  <b-tooltip target="salvarLocalCadastro" title="Salvar"></b-tooltip>

                </b-button>

                <b-button id="cancelarLocalCadastro" class=" my-2 ml-2" size="sm" pill variant="danger"
                  @click="cancelar">
                  <b-icon icon="x-circle" />
                  <b-tooltip target="cancelarLocalCadastro" title="Cancelar"></b-tooltip>

                </b-button>
              </b-col>
              <b-col cols="3"></b-col>

            </b-form-row>


          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import ResourceService from "@/core/api/ResourceService";
import { FormResourceMixin } from "@/core/mixins/resource";

export default {
  components: {
    LgFormInput,
  },
  data() {
    return {
      showModal: true,
      options: [
        { text: "Ativo", value: "1" },
        { text: "Inativo", value: "0" },
      ],
      form: {
        descricao: "",
        situacao: 1,
      },
    };
  },
  mixins: [ConfirmMixin, FormResourceMixin],
  props: {
    prefix: {
      type: Array,
      required: true,
    },
    id: {
      type: Number,
      default: null,
    },
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/pais`);
    if (this.id) {
      const { data } = await this.$service.findById(this.id);
      this.form = data;
    }
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, "Cadastro"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  methods: {
    async submitForm() {
      
      try {
        await this.$service.save(this.form);
        this.$notify({
          type: "success",
          message: 'Registro salvo com sucesso'
        });
        this.cancelar();

      } catch (e) {
        this.$notify({
          type: "danger",
          message: 'Este registro já está cadastrado'
        });
        return;
      }
    },

    cancelar() {
      this.$emit("fechar");
    },
  },
};
</script>
